import React from 'react';
import PropTypes from 'prop-types';
import CommonStrings from 'resources/common-strings';
import CommonValues from 'resources/common-values';
import CreateReactClass from 'create-react-class';
import numeral from 'numeral';

export default CreateReactClass({
    displayName: 'ComparisonsExpandedQuadrantChart',

    propTypes: {
        subjectBid: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        studentFirstName: PropTypes.string.isRequired,
        studentGender: PropTypes.string.isRequired,
        growthPercentile: PropTypes.number,
        achievementPercentile: PropTypes.number,
    },

    renderDescription(subjectName) {
        const getRange = (percentage, type) => {
            const high = 'High ';
            const average = 'Average ';
            const low = 'Low ';

            return percentage === 50 ? average + type : percentage < 50 ? low + type : high + type;
        };

        const achievementOrdinal = numeral(this.props.achievementPercentile).format('0o');
        const achievementRange = getRange(this.props.achievementPercentile, 'Achievement');
        //[Student's First Name] is in the [[growth percentile] percentile for Growth and the] [Achievement percentile] percentile in Achievement. [This places [gender pronoun] in the [High/Low Growth], [High/Low Achieving]] quadrant.1

        if (this.props.growthPercentile) {
            const growthOrdinal = numeral(Math.round(this.props.growthPercentile)).format('0o');
            const growthRange = getRange(Math.round(this.props.growthPercentile), 'Growth');
            //[Student's First Name] is in the [[growth percentile] percentile for Growth and the] [Achievement percentile]
            // percentile in Achievement. [This places [gender pronoun] in the [High/Low Growth], [High/Low Achieving]] quadrant.1
            return (
                <span>
                    <span className="growth-description-text">{`${this.props.studentFirstName} is in the `}</span>
                    <span className="growth-description-text strong">{`${growthOrdinal} percentile for Growth `}</span>
                    <span className="growth-description-text">{'and the '}</span>
                    <span className="growth-description-text strong">
                        {`${achievementOrdinal} percentile for Achievement. `}
                    </span>
                    <span className="growth-description-text">{`This places them in the `}</span>
                    <span className="growth-description-text strong">{`${growthRange}, ${achievementRange} `}</span>
                    <span className="growth-description-text">{'quadrant.'}</span>{' '}
                    <span className="growth-description-link">
                        <a
                            href={CommonStrings.comparisonsExpandedGrowthDescriptionLink.target}
                            target="_blank"
                            key="growth-description-link"
                            id={`comparisons-growth-description-link-${subjectName}-${this.props.studentBid}`}
                        >
                            {CommonStrings.comparisonsExpandedGrowthDescriptionLink.displayText}
                        </a>
                    </span>
                </span>
            );
        } else {
            // [Student's First Name] is in the [Achievement percentile] percentile in Achievement.1
            return (
                <span>
                    <span className="growth-description-text">{`${this.props.studentFirstName} is in the `}</span>
                    <span className="growth-description-text strong">
                        {`${achievementOrdinal} percentile in Achievement.`}
                    </span>{' '}
                    <span>
                        <a
                            href={CommonStrings.comparisonsExpandedGrowthDescriptionLink.target}
                            target="_blank"
                            key="conditional-growth-link"
                            id={`comparisons-growth-description-link-${subjectName}-${this.props.studentBid}`}
                        >
                            {CommonStrings.comparisonsExpandedGrowthDescriptionLink.displayText}
                        </a>
                    </span>
                </span>
            );
        }
    },

    render() {
        const subjectName = CommonValues.getSubjectFieldforBid(this.props.subjectBid, 'shortName');
        return (
            <div
                className="growth-and-achievement-expanded-description"
                id={`comparisons-growth-and-achievement-expanded-description-${subjectName}-${this.props.studentBid}`}
            >
                {this.renderDescription(subjectName)}
            </div>
        );
    },
});
